"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalTiesValidationCheckType = void 0;
exports.validateSignalTies = validateSignalTies;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
var SignalTiesValidationCheckType;
(function (SignalTiesValidationCheckType) {
    SignalTiesValidationCheckType["SelfReferentialTiesShouldNotExist"] = "SelfReferentialTiesShouldNotExist";
    SignalTiesValidationCheckType["ComponentValueShouldParse"] = "ComponentValueShouldParse";
})(SignalTiesValidationCheckType || (exports.SignalTiesValidationCheckType = SignalTiesValidationCheckType = {}));
function validateSignalTies(signalTies, logger) {
    const flattenedTies = [];
    for (const signalTie of signalTies) {
        for (const tie of signalTie.ties) {
            flattenedTies.push({
                signalName: signalTie.signalName,
                tie,
            });
        }
    }
    const { validatedEntries: validFlattenedTies, validationResults } = sigma_engine_shared_1.TableValidationTools.applyValidationCheck(flattenedTies, (entries) => {
        const failures = [];
        entries.forEach((entry, i) => {
            if (entry.signalName === entry.tie.toSignalName) {
                failures.push({
                    index: i,
                    message: `Self-referential tie: ${entry.signalName} → ${entry.tie.toSignalName}`,
                    details: `Connection type: ${entry.tie.connectionType}`,
                });
            }
        });
        return failures;
    }, SignalTiesValidationCheckType.SelfReferentialTiesShouldNotExist, {
        dropFailingEntries: true,
        logger,
    });
    const resultMap = new Map();
    for (const flattenedTie of validFlattenedTies) {
        const existing = resultMap.get(flattenedTie.signalName);
        if (existing) {
            existing.push(flattenedTie.tie);
        }
        else {
            resultMap.set(flattenedTie.signalName, [flattenedTie.tie]);
        }
    }
    const validatedSignalTies = [];
    for (const [signalName, ties] of resultMap.entries()) {
        validatedSignalTies.push({ signalName, ties });
    }
    return {
        validatedSignalTies,
        validationResults,
    };
}
//# sourceMappingURL=signal-ties-denormalized.validation.js.map